
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gnTESkh8AdMvRTFXdzCmB7ilbDZzrQwHBV7bJYeaoul0Meta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indextXY9ujfi_4573uyf6Cp70H0JCsYOP9wGiV9YyUYRN_45z5oMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchX9e2DrapnH9YiQM2ck7oZBR2zz4CMk9o25zBaQU4IcMMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexJzX72qnoXP84YrC5Grte0H2l9aKyFn_45oUFZSj9aTCYAMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93paU6i9DWfjpnTt880KAfdTOOrP4oAtS80V918yK4OoAMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgImRJ41pwUY_zRRptFdLEuAXijRFDauP_peALS9_vDsMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_939BqkujdNjXZWXxbXsddsXLvgL9I01yLZ_Ai_MyM_45B7cMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexY4y1GJ1VVi630oytzwU1z9PTG4PFkKrqTY1C9rzLXS0Meta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93n1rO_pL4WVJ7t69zEMkyQyUqeUbR2dJK7jX8k6UHTRIMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexasIraQznCp9yPu21_45A4yR43OG7u26TnY__45Aw9kt5FIUMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexP6_8aIVPkM2AraKM9lz84qdRPqA2qULu81kXRCxcNCoMeta } from "/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgImRJ41pwUY_zRRptFdLEuAXijRFDauP_peALS9_vDsMeta || {},
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexY4y1GJ1VVi630oytzwU1z9PTG4PFkKrqTY1C9rzLXS0Meta || {},
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexasIraQznCp9yPu21_45A4yR43OG7u26TnY__45Aw9kt5FIUMeta || {},
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexP6_8aIVPkM2AraKM9lz84qdRPqA2qULu81kXRCxcNCoMeta || {},
    component: () => import("/codebuild/output/src123968317/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]